import { defineComponent as _defineComponent } from 'vue'
import CcCard from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCard.ts.vue';
import CcCardItem from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCardItem.ts.vue';
import CcCheckboxLarge from '@/views/Automation/CampaignCreatorV2/components/CcCheckbox/CcCheckboxLarge.ts.vue';
import CcError from '@/views/Automation/CampaignCreatorV2/components/CcError/CcError.ts.vue';
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import CcBuildUrlParameterModal from '@/views/Automation/CampaignCreatorV2/components/Modals/CcBuildUrlParameterModal.ts.vue';
import useCreativeStore from '@/views/Automation/CampaignCreatorV2/store/Creative';
import { CardLayer } from '@/views/Automation/CampaignCreatorV2/types';
import { BFormInput } from 'bootstrap-vue';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Destination.ts',
  setup(__props) {

const creativeStore = useCreativeStore();
const creativeGetters = storeToRefs(creativeStore);

const buildUrlParameterModal = ref<NullableType<InstanceType<typeof CcBuildUrlParameterModal>>>(null);

const urlInput = ref<NullableType<InstanceType<typeof BFormInput>>>(null);

const websiteDestinationType = computed(() => creativeGetters.getInternalMetadata.value('website_destination_type'));

const url = computed(() => creativeGetters.getField.value('link_url')?.value?.[0] || {});

const displayLink = computed(() => creativeGetters.getField.value('link_destination_display_url')?.value?.[0] || {});

function onOpenUrlModal() {
  buildUrlParameterModal.value?.onModalOpen();
}

function onWebsiteDestinationTypeChange(value: boolean) {
  creativeStore.updateInternalMetadata('website_destination_type', value);
}

function onDisplayLinkChange(value: string) {
  creativeStore.addOrEditVariable('link_destination_display_url', {
    field: 'link_destination_display_url',
    value,
    variableId: 'link_destination_display_url',
  });
}

function onUrlChange(value: string) {
  creativeStore.addOrEditVariable('link_url', { field: 'link_url', value, variableId: 'link_url' });
}

return { __sfc: true,creativeStore, creativeGetters, buildUrlParameterModal, urlInput, websiteDestinationType, url, displayLink, onOpenUrlModal, onWebsiteDestinationTypeChange, onDisplayLinkChange, onUrlChange, CcCard, CcCardItem, CcCheckboxLarge, CcError, CcIcon, CcBuildUrlParameterModal, CardLayer, BFormInput }
}

})